export const PUBLISHED_LIST_ORDER_DEFAULT = "publishedAt:desc";

export const PUBLISHED_LIST_ORDER_OPTIONS = [
    { value: "publishedAt:desc", label: "Published desc" },
    { value: "publishedAt:asc", label: "Published asc" },
    { value: "createdAt:desc", label: "Created desc" },
    { value: "createdAt:asc", label: "Created asc" },
];

export function publishedListSort(orderValue) {
    const [field, dir] = String(orderValue || PUBLISHED_LIST_ORDER_DEFAULT).split(":");
    if (
        (field === "publishedAt" || field === "createdAt")
        && (dir === "asc" || dir === "desc")
    ) {
        return [{ field, sort: dir }];
    }
    return [{ field: "publishedAt", sort: "desc" }];
}
